export const hasUsableInvoiceAddress = (address) => {
  if (!address || address === 1) return false;
  if (typeof address === 'string') {
    const raw = address.trim();
    return Boolean(raw) && raw !== '1' && !/^(?:n\/a|none|unknown|cust-[\w-]+)$/i.test(raw);
  }
  if (typeof address !== 'object') return false;
  const fields = [
    address.street, address.streetAddress, address.addressLine1,
    address.address1, address.line1, address.Line1,
  ];
  if (fields.some((item) => String(item || '').trim())) return true;
  if (typeof address.address === 'string') return hasUsableInvoiceAddress(address.address);
  return false;
};

export const missingInvoiceAddresses = (invoice = {}) => {
  const missing = [];
  if (!hasUsableInvoiceAddress(invoice.billingAddress)) missing.push('Billing address');
  if (!hasUsableInvoiceAddress(invoice.shippingAddress)) missing.push('Shipping address');
  return missing;
};
